var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AcknowledgeProblem',{attrs:{"source":_vm.source,"trigger-id":_vm.triggerId,"installation-id":_vm.installationId}})}
var staticRenderFns = []

export { render, staticRenderFns }